<script setup lang="ts">
  //
</script>

<template>
  <div class="mb-6 flex flex-wrap items-end text-sm text-gray-500 xl:mb-4">
    <slot></slot>
  </div>
</template>


